<div class="wrapper-loading">
    <div class="loading-container">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p>Loading...</p>
    </div>
</div>